import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsIntegromatComponent } from './simple-icons-integromat.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsIntegromatComponent ],
    exports:      [ SimpleIconsIntegromatComponent ],
    bootstrap:    []
})
export class SimpleIconsIntegromatModule {}
